import { useState } from "react"

import { API_URL as API } from "../config"

function Auth({ onLogin }) {
  const [modo, setModo] = useState("login")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [nombre, setNombre] = useState("")
  const [codigo, setCodigo] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [loading, setLoading] = useState(false)

  const cambiarModo = (m) => {
    setModo(m)
    setError("")
    setSuccess("")
  }

  const handleSubmit = async () => {
    setError("")
    setSuccess("")
    setLoading(true)
    try {
      if (modo === "registro") {
        const res = await fetch(`${API}/auth/registro`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, nombre })
        })
        const data = await res.json()
        if (res.ok) {
          setModo("verificar")
          setSuccess("Revisa tu bandeja de entrada para el código de verificación.")
        } else {
          setError(data.detail)
        }

      } else if (modo === "verificar") {
        const res = await fetch(`${API}/auth/verificar`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, codigo })
        })
        if (res.ok) {
          setModo("login")
          setSuccess("Email verificado correctamente. Ya puedes iniciar sesión.")
        } else {
          const data = await res.json()
          setError(data.detail)
        }

      } else {
        const res = await fetch(`${API}/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password })
        })
        const data = await res.json()
        if (res.ok) {
          onLogin(data.token, data.userId, data.nombre)
        } else {
          setError(data.detail)
        }
      }
    } catch {
      setError("Error de conexión. Verifica que el servidor está activo.")
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) handleSubmit()
  }

  return (
    <div className="auth-container">
      <div className="auth-brand">
        <div className="auth-brand-icon">J</div>
        <h1>Jaureguichat</h1>
        <p>Chat anónimo en tiempo real</p>
      </div>

      <div className="auth-box">
        {modo !== "verificar" && (
          <div className="auth-tabs">
            <button
              className={modo === "login" ? "active" : ""}
              onClick={() => cambiarModo("login")}
            >
              Iniciar sesión
            </button>
            <button
              className={modo === "registro" ? "active" : ""}
              onClick={() => cambiarModo("registro")}
            >
              Crear cuenta
            </button>
          </div>
        )}

        {modo === "verificar" && (
          <div className="verify-header">
            <div className="verify-icon">✉</div>
            <h3>Verifica tu email</h3>
            <p>Enviamos un código a <strong>{email}</strong></p>
          </div>
        )}

        {modo === "registro" && (
          <div className="form-group">
            <label>Tu nombre</label>
            <input
              placeholder="Nombre o apodo"
              value={nombre}
              onChange={e => setNombre(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        )}

        {modo !== "verificar" && (
          <>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="form-group">
              <label>Contraseña</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          </>
        )}

        {modo === "verificar" && (
          <div className="form-group">
            <label>Código de verificación</label>
            <input
              placeholder="123456"
              value={codigo}
              onChange={e => setCodigo(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
              className="code-input"
            />
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading
            ? <span className="btn-loading"><span /><span /><span /></span>
            : modo === "login"
              ? "Iniciar sesión"
              : modo === "registro"
                ? "Crear cuenta"
                : "Verificar código"
          }
        </button>

        {modo === "verificar" && (
          <button className="btn-link" onClick={() => cambiarModo("login")}>
            ← Volver al login
          </button>
        )}
      </div>
    </div>
  )
}

export default Auth